import { BulkActionJob, BulkActionRequest } from "../models/bulkActions";
import { ProjectId } from "../types";
import { Endpoints } from "./constants";
import { AssetsHttpClient } from "./createAssetsHttpClient";

export const getBulkActionsClient = (
  http: AssetsHttpClient,
  projectId: ProjectId
) => {
  const base = http.getAssetsServiceBasePath(projectId, "v2");

  return {
    get: (id: BulkActionJob["id"]): Promise<BulkActionJob> =>
      http.get<BulkActionJob>(`${base}/${Endpoints.BulkActions}/${id}`),

    create: (request: BulkActionRequest): Promise<BulkActionJob> =>
      http.post<BulkActionJob>(`${base}/${Endpoints.BulkActions}`, {
        body: JSON.stringify(request),
      }),
  };
};

/**
 * The shape returned by {@link getBulkActionsClient}.
 * Exported so consumers can type variables without spelling out
 * `ReturnType<typeof getBulkActionsClient>`.
 */
export type BulkActionsClient = ReturnType<typeof getBulkActionsClient>;
